import React from "react";
import "./Contact.css";

const Contact = () => {
  return (
    <section id="contact">
      <h2>Contact Us 📞</h2>
      <article>
        <h3>Call us from Monday to Saturday, 9 AM - 5P M</h3>
        <ul>
          <li>
            Phone 📞:{" "}
            <a href="tel: +251974747975" rel="noreferrer" target="_blank">
              +251974747975
            </a>
          </li>
        </ul>
        <h3>Email Us</h3>
        <ul>
          <li>
            Email 📧:{" "}
            <a
              href="mailto: mihiretbonda@gmail.com"
              rel="noreferrer"
              target="_blank"
            >
              mihiretbonda@gmail.com
            </a>
          </li>
        </ul>
        <h3>You can find us on Social Medias</h3>
        <h4>Telegram</h4>
        <ul>
          <li>
            Direct Message 📤:{" "}
            <a
              href="https://t.me/MihiretBondaCC"
              rel="noreferrer"
              target="_blank"
            >
              Mihiret Bonda
            </a>
          </li>
          <li>
            Channel 📢:{" "}
            <a
              href="https://t.me/MihiretBonda"
              rel="noreferrer"
              target="_blank"
            >
              Mihiret Bonda Clothes & Shoes Shopping 👗👚👕👖👟🥿
            </a>
          </li>
          <li>
            Discussion group 💬🗣:{" "}
            <a
              href="https://t.me/MihiretBondaDiscussion"
              rel="noreferrer"
              target="_blank"
            >
              Mihiret Bonda Clothes Shopping Discussion 💬
            </a>
          </li>
        </ul>
        <h4>Facebook</h4>
        <ul>
          <li>
            Facebook Page 📄:{" "}
            <a
              href="https://www.facebook.com/share/161UUmV6k5/"
              rel="noreferrer"
              target="_blank"
            >
              Mihiret Bonda Cloths Shopping
            </a>
          </li>
        </ul>
      </article>
    </section>
  );
};

export default Contact;
